const actions = {
  SET_BALANCE: 'SET_BALANCE',

  FETCH_BALANCE_REQUEST: 'FETCH_BALANCE_REQUEST',
  FETCH_BALANCE_SUCCESS: 'FETCH_BALANCE_SUCCESS',
  FETCH_BALANCE_FAILURE: 'FETCH_BALANCE_FAILURE',

  INCREASE_BALANCE: 'INCREASE_BALANCE',
  DECREASE_BALANCE: 'DECREASE_BALANCE',

  setBalance: (amount) => {
    return {
      type: actions.SET_BALANCE,
      amount: amount,
    };
  },

  increaseBalance: (amount) => {
    return {
      type: actions.INCREASE_BALANCE,
      amount: amount,
    };
  },

  decreaseBalance: (amount) => {
    return {
      type: actions.DECREASE_BALANCE,
      amount: amount,
    };
  },
};

export default actions;
